export type SetupDetailRow = {
  readonly label: string
  readonly value: string
}

/**
 * A titled list of read-only label/value rows, shared by the Battery and Solar
 * Site Information steps so both read alike. The caller owns each value's
 * fallback.
 */
export const SetupDetailSection = ({
  note,
  rows,
  title,
}: {
  note?: string
  rows: readonly SetupDetailRow[]
  title: string
}): JSX.Element => (
  <section aria-label={title}>
    <h3 className="mb-3 text-xs font-semibold tracking-wide text-muted uppercase">
      {title}
    </h3>
    <dl className="divide-y divide-border overflow-hidden rounded-xl border border-border bg-surface">
      {rows.map((row) => (
        <div
          key={row.label}
          className="grid grid-cols-1 gap-1 px-4 py-3 sm:grid-cols-[minmax(7rem,0.6fr)_minmax(0,1fr)] sm:gap-4"
        >
          <dt className="text-sm text-muted">{row.label}</dt>
          <dd className="min-w-0 text-sm font-semibold break-words text-foreground">
            {row.value}
          </dd>
        </div>
      ))}
    </dl>
    {note ? <p className="mt-3 text-sm text-muted">{note}</p> : null}
  </section>
)
